import React from 'react';
import { Box, Typography } from '@mui/material';
import { NavLink } from 'react-router-dom';
import HomeIcon from 'app/components/Icons/HomeIcon';
import MenuEditIcon from 'app/components/Icons/MenuEditIcon';
import JudgeIcon from 'app/components/Icons/JudgeIcon';
import SwitchIcon from 'app/components/Icons/SwitchIcon';
import WalletIcon from 'app/components/Icons/WalletIcon';
import SafeIcon from 'app/components/Icons/SafeIcon';
import PercentIcon from 'app/components/Icons/PercentIcon';
import CoinsStakedIcon from 'app/components/Icons/CoinsStakedIcon';
import LoadIcon from 'app/components/Icons/LoadIcon';
import MenuCalendarIcon from 'app/components/Icons/MenuCalendarIcon';
import OthersIcon from 'app/components/Icons/OthersIcon';
import { activeLink, links, sidebarMenuBox, notif, notifText, menuBox } from './SidebarMenu.sx';
import { MenuData } from 'app/constants/types';
import { grey10 } from 'app/components/ThemeProvider/colors';
import logger from 'app/utils/logger';

const menus = [
  { icon: <HomeIcon />, title: 'Ana səhifə', path: '/az/home-page' },
  { icon: <MenuEditIcon />, title: 'İmzalanmalı əməliyyatlar', path: '/az/signed-operations', amount: 5 },
  { icon: <JudgeIcon />, title: 'Sərəncamlar', path: '/az/payment-orders' },
  { icon: <SwitchIcon />, title: 'Köçürmələr və ödənişlər', path: '/az/transfer-page' },
  { icon: <WalletIcon />, title: 'Hesablar və kartlar', path: '/az/accounts-cards' },
  { icon: <SafeIcon />, title: 'Əmanətlər', path: '/az/deposits' },
  { icon: <PercentIcon />, title: 'Kreditlər', path: '/az/credits' },
  { icon: <CoinsStakedIcon />, title: 'Əmək haqqı', path: '/az/salary' },
  { icon: <LoadIcon />, title: 'Sifarişlər', amount: 2, path: '/az/orders' },
  { icon: <MenuCalendarIcon />, title: 'Onlayn növbə', path: '/az/queue' },
  { icon: <OthersIcon />, title: 'Digər', path: '/az/others' },
];

interface Props {
  menu: MenuData[];
  setOpen?: (state: boolean) => void;
}

const SidebarMenu = (props: Props) => {
  const { menu, setOpen } = props;

  if (menu === undefined) {
    return <Box sx={{ height: 'calc(100vh - 110px)', width: '26%', background: grey10 }}></Box>;
  }
  logger.log(menu);

  return (
    <Box sx={sidebarMenuBox}>
      <Box sx={menuBox}>
        {menu.map((item) => (
          <NavLink
            to={
              item.id === 'account_list'
                ? `${item.path_front}?type=accounts`
                : item.id === 'salary_list'
                ? `${item.path_front}?type=new-payments`
                : item.path_front
            }
            key={item.title}
            style={({ isActive }) => (isActive ? { ...activeLink, ...links } : { ...links })}
            onClick={() => {
              setOpen && setOpen(false);
            }}
          >
            <img src={item.icon} alt="" />
            {item.title}
            {item.count && (
              <Box sx={notif}>
                <Typography sx={notifText}>{item.count}</Typography>
              </Box>
            )}
          </NavLink>
        ))}
      </Box>
    </Box>
  );
};

export default SidebarMenu;
